import React from 'react';
import { Label } from 'semantic-ui-react';
import { PosVendaProtocoloStatus, PosVendaSlaEstado } from '../../../types/posVenda';
import { slaCor, slaRotulo } from '../../../utils/posVenda/posVendaSlaDisplay';
import { slaEstadoEstaPendente } from '../../../utils/posVenda/posVendaSlaEstado';
import { slaEstaPausado } from '../../../utils/posVenda/posVendaSlaStatus';

interface SlaBadgeProps {
  estado: PosVendaSlaEstado;
  percentual?: number;
  status?: PosVendaProtocoloStatus;
}

export const SlaBadge: React.FC<SlaBadgeProps> = ({ estado, percentual, status }) => {
  const pendente = slaEstadoEstaPendente(estado);
  const cor = slaCor(estado);
  const pausado = pendente && status != null && slaEstaPausado(status);
  return (
    <Label
      size="small"
      style={{
        backgroundColor: `${cor}22`,
        color: cor,
        border: `1px solid ${cor}`,
      }}
    >
      {slaRotulo(estado)}
      {pendente && percentual != null ? ` · ${Math.round(percentual)}%` : ''}
      {pausado ? ' · SLA pausado' : ''}
    </Label>
  );
};

export default SlaBadge;
